/**
 * Created by matheusmorett on 16/08/17.
 */
import Menu from './Menu';
export default Menu;
